export const CompulsoryIndicator = () => (
	<span className="text-danger"> *</span>
);
